<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">受け取った感想</li>
            </ol>
        </nav>
        <div class="container">
            <div class="row">
                <div class="col-md-4 pt-4 mt-4">
                    <div>
                        <h6>感想は作者にしか見えません</h6>
                        <p>
                            感想は作者にしか見えません。第三者に表示されることはありません。
                            そのためネタバレや他の読者に読まれて困る内容の感想も、安心して受け取ることができます。
                        </p>
                        <h6>感想に返信することができます（公開されます）</h6>
                        <p>
                            感想には返信することができます。
                            返信は作者のみが行うことができ、投稿者は更にそれに返信することはできません。
                            匿名の読者からの感想に返信した場合、<b>その返信は一言欄で公開されます。</b>
                            ご注意ください。<br>
                            一言欄を非表示にしている場合は、返信は表示されません。
                        </p>
                        <h6>ガイドライン違反はご報告ください</h6>
                        <p>
                            誹謗中傷や作品と無関係な宣伝、悪意のある感想を書き込まれた場合は、レポートからご連絡ください。<br>
                            明確なガイドライン違反でなくとも、不快な感想を連投された場合は、
                            <span class="badge badge-danger"><i class="fas fa-volume-mute"></i></span>
                            ミュートボタンから対象者の感想をすべてミュート（非表示）にできます。
                            ミュートされたことは、相手にはわかりません。
                            ミュートはログインユーザに対してのみ使用できます。
                        </p>
                        <p>
                            <router-link to="/mypage/reviews/mutes">
                                <i class="fas fa-volume-mute"></i>
                                ミュート一覧
                            </router-link>
                        </p>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="sticky">
                        <page :last_page="reviews.last_page" v-model="page" @goto="goto"></page>
                    </div>
                    <div v-if="reviews.total">
                        <div class="review" v-for="r in reviews.data" :key="r.id">
                            <div class="book mincho">
                                <h5 v-html="$filters.ruby(r.book.title)"></h5>
                                <h6>{{r.book.subtitle}}</h6>
                            </div>
                            <div class="px-2">
                                <div v-if="r.applause">
                                    <span class="badge badge-pills badge-info">
                                        <h6 class="m-0">{{r.applause.caption}}</h6>
                                    </span>
                                </div>
                                <div class="review-item mincho" v-html="$filters.wrap(r.body)"></div>
                                <div class="text-right text-muted mincho">
                                    <div v-if="r.section">
                                        <a :href="episodeLink(r)">
                                            <span v-if="r.section.section_name">「{{r.section.section_name}}」</span>
                                            <span v-else>無題</span>
                                        </a>
                                    </div>
                                    <div>
                                        <div v-if="r.user">
                                            <ruby>{{r.user.name}}<rt>{{r.user.kana}}</rt></ruby>
                                            <a href="#" class="badge badge-danger" title="ミュートにする" @click.prevent="mute(r)">
                                                <i class="fas fa-volume-mute"></i>
                                            </a>
                                        </div>
                                        <div class="small">{{$filters.dateFormat(r.created_at)}}</div>
                                    </div>
                                </div>
                                <div class="reply mincho" v-html="$filters.wrap(r.reply)" v-if="r.reply"></div>
                                <div class="d-flex justify-content-between">
                                    <button type="button" class="btn btn-outline-primary btn-sm" @click="reply(r)">
                                        <span v-if="!r.reply">返信する</span>
                                        <span v-else>返信を編集する</span>
                                    </button>
                                    <button type="button" class="btn btn-outline-danger btn-sm" @click="remove(r)">
                                        削除する
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="nothing">
                        投稿された感想はありません。
                    </div>
                </div>
            </div>
        </div>
        <reply-modal :review_id="review_id" @saved="load()"></reply-modal>
    </div>
</template>

<style scoped lang="scss">
.review {
    margin: 1rem 0;
    padding: 1rem 0;
    border-bottom: 1px solid #ddd;
    .book {
        text-align: center;
        padding: 1rem 1rem .5rem;
        margin: .5rem 0;
        border-radius: .5rem .5rem 0 0;
    }
    .review-item {
        font-size: 1.1rem;
        padding: .5rem .5rem 1rem;
    }
    .reply {
        border-top: 1px dotted #ddd;
        padding: 1rem;
    }
}
</style>

<script>
import page from "components/Page";
import replyModal from "./reply";
export default {
    components: {
        page,
        replyModal,
    },
    data() {
        return {
            reviews: [],
            page: 1,
            review_id: null,
            routeWatcher: null,
        }
    },
    methods: {
        goto(p) {
            this.page = p;
            setTimeout(() => {this.load()});
        },
        load() {
            $("html,body").animate({scrollTop: 0}, 300);
            axios.get("/mypage/reviews/received/get", {params: {
                page: this.page
            }}).then(res => {
                this.reviews = res.data;
            }).catch(err => {
                alert.err(err.response);
            });
        },
        reply(r) {
            this.review_id = r.id;
            setTimeout(() => {
                $("#reply-modal").modal();
            });
        },
        toggleApply(r) {
            axios.post("/mypage/review/apply/toggle", r).then(res => {
                alert.msg(res.data);
                this.load();
            }).catch(err => {
                alert.err(err.response);
            });
        },
        mute(r) {
            Swal.fire({
                title: "ミュートにする",
                html: `<div class='text-left'>
                <b>${r.user.name}</b> さんをミュートにします。<br>
                この感想も含めて、あなたへの感想がすべて見えなくなります。<br>
                ミュートされたことは相手にはわかりません。<br>
                よろしいですか？
                </div>`,
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "ミュートする",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/mute", {'id': r.user_id}).then(res => {
                        alert.msg(res.data);
                        this.load();
                    }).catch(err => { alert.err(err.response); });
                }
            });
        },
        episodeLink(r) {
            let subdomain = this.$store.state?.user?.subdomain || "www";
            return "//" + subdomain + this.$store.state.base_domain + "/author/page/"
                + r.book.id + "/section/" + r.section.id;
        },
        remove(r) {
            Swal.fire({
                title: "感想を削除する",
                html: `<div class='text-left'>
                この感想を完全に削除します。<br>
                削除した感想はもとに戻りません。<br>
                よろしいですか？
                </div>`,
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "削除する",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/review/remove", {'id': r.id}).then(res => {
                        alert.msg(res.data);
                        this.load();
                    }).catch(err => { alert.err(err.response); });
                }
            });
        }
    },
    mounted() {
        this.load();
        this.routeWatcher = this.$watch('$route', (o, n) => {
            this.reviews = [];
            this.load();
        });
        setTimeout(() => {
            this.useHead({
                title: "受け取った感想 | 貸し本棚",
                link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ],
                meta: [
                    { name: "keywords", content: "貸し本棚,小説投稿,Web小説,小説展示,オンライン小説,縦書き小説,置き場,文芸,ライトノベル", id: "meta-keywords" },
                    { name: "description", content: "小説を書くこと、読むことにフォーカスした小説投稿サイトです。作家さん独自のサブドメインで、ご自身の小説を公開できます。横断的に編集ができるエディタで原稿執筆することも、過去の作品をレーティングを気にせず展示することもできます。", id: "meta-description" }
                ]
            });
        }, 1000);
    },
    beforeRouteLeave(to, from) {
        this.routeWatcher();
    }
}
</script>